window.$ = jQuery;
import gsap from 'gsap';

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Sliders = (function() {

    $(window).on("load", function() {
        $(".feature-category__slider.swiper").each(function() {
            const $pagination = $(this).find(".swiper-pagination");
            const swiper = new Swiper($(this)[0], {
                modules: [Pagination],
                autoHeight: false,
                slidesPerView: 1.2,
                spaceBetween: 20,
                loop: false,
                keyboard: {
                    enabled: true,
                },        
                pagination: {
                    el: $pagination[0],
                }
            });
        });
    
        $(".feature-media__slideshow .swiper-and-controls").each(function() {
            const $pagination = $(this).parent().find(".swiper-pagination");
            const $caption = $(this).parent().find(".slideshow-footer .image-caption");
            const $left = $(this).find(".swiper-button-prev");
            const $right = $(this).find(".swiper-button-next");
            const $that = $(this);

            const swiper = new Swiper($(this)[0], {
                modules: [Pagination, Navigation],
                autoHeight: true,
                createElements: true,
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                keyboard: {
                    enabled: true,
                },        
                navigation: {
                    nextEl: $right[0],
                    prevEl: $left[0]
                },
                pagination: {
                    el: $pagination[0]
                }
            });

            const setButtonHeight = function() {
                var activeSlideHeight = $that.find(".swiper-slide-active").height();
                $that.find(".swiper-controls").css("height", activeSlideHeight + "px");
            }

            setButtonHeight();

            swiper.on('slideChangeTransitionEnd', setButtonHeight);

            swiper.on('slideChange', function (e) {
                var caption = $(swiper.slides[swiper.realIndex]).find("img").attr("data-caption");
                $caption.text(caption);
                var activeSlideHeight = $(".swiper-slide-active").height();
                $(".swiper-controls").css("height", activeSlideHeight + "px");    
            });

            $(window).on("resize", function() {
                var debounceResize;
                clearTimeout(debounceResize);
                debounceResize = setTimeout(function() {
                    setButtonHeight();
                }, 100);
            });
        });
    
        $(".post-carousel__post").each(function() {
            var $content = $(this).find(".post-carousel__post-content");
            var $image = $(this).find(".post-carousel__post-image img");
            $content.css("max-width", $image.width() + "px");
        });
    
        $(".post-carousel .swiper").each(function() {
            const $navigation = $(this).parent().find(".post-carousel__nav");
            const $pagination = $(this).find(".swiper-pagination");
            const $left = $navigation.find(".left-button");
            const $right = $navigation.find(".right-button");
            const $count = $(this).parent().find(".current-count");
    
            const swiper = new Swiper($(this)[0], {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: "auto",
                spaceBetween: 20,
                keyboard: {
                    enabled: true,
                },        
                navigation: {
                    nextEl: $right[0],
                    prevEl: $left[0]
                },
                pagination: {
                    el: $pagination[0],
                },
                breakpoints: {
                    640: {
                        spaceBetween: 0,
                        pagination: false
                    },
                }
            });
    
            swiper.on('slideChange', function () {
                $count.text(swiper.activeIndex + 1);
            });
              
        });
    
        $(".publications-cta__publications--mobile").each(function() {
            const $pagination = $(this).find(".swiper-pagination");
            const swiper = new Swiper($(this)[0], {
                modules: [Navigation, Pagination],
                loop: false,
                slidesPerView: 1.25,
                spaceBetween: 20,
                keyboard: {
                    enabled: true,
                },        
                pagination: {
                    el: $pagination[0],
                },
                breakpoints: {
                    640: {
                        spaceBetween: 0
                    },
                }
            });
        });    
    });

})();